<script>
import DailyJournalReportService from '@/services/DailyJournalReportService'
import moment from 'moment'

export default {
  props: {
    locationId: {
      default () {
        return [0]
      }
    },
    startDate: {
      type: String,
      default () {
        return moment().format('YYYY-MM-DD')
      }
    },
    endDate: {
      type: String,
      default () {
        return ''
      }
    },
    shiftId: {
      default () { return 0 }
    },
    promoId: {
      default () { return 0 }
    },
    checkId: {
      default () { return 0 }
    },
    employeeId: {
      default () { return 0 }
    },
    discountOnly: {
      default () { return 0 }
    },
    voidOnly: {
      default () { return 0 }
    },
    itemId: {
      default () { return 0 }
    },
    inday: {
      default () { return false }
    }
  },
  data () {
    return {
      openModal: false,
      checkData: [],
      colSpan: {
        total: 5,
        details: 10
      }
    }
  },
  methods: {
    totalColSpan: function () {
      if (this.employeeId > 0) {
        this.colSpan.total = 4
        this.colSpan.details = 9
      }
    },
    openView: function () {
      // get data
      this.$updateloading(1)
      DailyJournalReportService.getChecks({
        location_id: this.locationId,
        date: this.startDate,
        shift_id: this.shiftId,
        discount: this.discountOnly,
        promo_id: this.promoId,
        check_id: this.checkId,
        employee_id: this.employeeId,
        voided: this.voidOnly,
        item_id: this.itemId,
        inday: this.inday
      })
        .then(res => {
          this.$updateloading(-1)
          this.checkData = res
          // display modal.
          this.openModal = true
          this.totalColSpan()
        }, (error) => {
          this.$updateloading(-1)
          this.$notify({
            group: 'errors',
            title: 'Error',
            text: error.message,
            type: 'warn'
          })
        })
    },
    showItems: function (check) {
      if (check.showitems === true) {
        check.showitems = false
      } else {
        check.loading = true
        check.showitems = true
        if (typeof check.items === 'undefined') {
          DailyJournalReportService.getCheckDetails(check.id, this.inday)
            .then(res => {
              check.items = res
              check.loading = false
              this.$forceUpdate()
            }, (error) => {
              this.$updateloading(-1)
              this.$notify({
                group: 'notices',
                title: 'Error',
                text: error.message,
                type: 'warn'
              })
            })
        } else {
          check.loading = false
        }
      }
    }
  }
}
</script>

<template>
  <span>
    <a
      href="#"
      v-on:click.prevent="openView()"
    >
      <slot></slot>
    </a>
    <b-modal
      v-model="openModal"
      ok-only
      ok-title="Close"
      size="xl"
      v-bind:title="checkData.title"
    >
      <div class="table-responsive">
        <table class="table table-sm table-bordered table-striped ">
          <thead>
            <tr class="table-header header text-left">
              <th class="text-center">
                <span class>Check #</span>
              </th>
              <th>
                <span class>Shift/Center</span>
              </th>
              <th v-if="employeeId == 0">
                <span class>Staff</span>
              </th>
              <th class="text-center">
                Times/Length
              </th>
              <th class="text-center">
                <span class>Guests</span>
              </th>
              <th class="text-right">
                <span class>Total</span>
              </th>
              <th class="text-center">
                <span class>Credits</span>
              </th>
            </tr>
          </thead>
          <tbody
            v-for="(c, cindex) in checkData.results"
            :key="cindex"
            v-show="checkData.results.length > 0"
          >
            <tr class="border-right">
              <td class="text-center text-nowrap">
                <a
                  href
                  class="link"
                  v-on:click.prevent="showItems(c)"
                >{{ c.checknumber }}
                  <span
                    v-show="!c.showitems"
                    class="oi oi-chevron-right"
                  ></span>
                  <span
                    v-show="c.showitems"
                    class="oi oi-chevron-bottom"
                  ></span>
                </a>
              </td>
              <td>{{ c.shift }}<br/>{{ c.profitcenter }}</td>
              <td v-if="employeeId == 0">{{ c.employee }}</td>
              <td class="text-center">{{ c.opened }} - {{ c.closed }}<br/> ({{ c.checklength }})</td>
              <td class="text-center">{{ c.guestcount }}</td>
              <td class="text-right" nowrap>
                <em>Sub:</em> {{ c.total | currency }}<br/>
                <em>Tax:</em> {{ c.taxes | currency }}<br/>
                <span v-if="c.discounts > 0"><em>Disc:</em> {{ c.discounts | currency }}<br/></span>
                <span v-if="c.voids > 0"><em>Vds:</em> {{ c.voids | currency }}</span>
              </td>
              <td
                class="text-center"
                v-html="c.credits"
              ></td>
            </tr>
            <tr v-show="c.showitems">
              <td></td>
              <td :colspan="colSpan.details - 1">
                <span v-if="c.loading">Loading...</span>
                <table
                  class="table table-condensed table-bordered table-striped checkdetailspopup"
                  v-show="!c.loading"
                >
                  <thead>
                    <tr>
                      <th class="text-center">Time</th>
                      <th>Item/Promo</th>
                      <th>Category</th>
                      <th class="text-right">Qty @ Per</th>
                      <th class="text-right">Subtotal</th>
                      <th>Reason (Manager)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(i, itemindex) in c.items"
                      :key="itemindex"
                      :class="{ 'bg-danger text-white': i.voided, 'bg-warning': i.promo }"
                    >
                      <td class="text-center">{{ i.ttime }}</td>
                      <td>
                        <span v-show="i.promo">{{ i.promo }}</span>
                        <span v-show="!i.promo">{{ i.itemlisting }}</span>
                      </td>
                      <td>{{ i.category }}</td>
                      <td class="text-right">
                        <span v-show="!i.promo && !i.voided">{{ i.quantity }} @ {{ i.peritem | currency }}</span>
                      </td>
                      <td class="text-right">{{ i.amount | currency }}</td>
                      <td>
                        <span v-show="i.voided">{{ i.voidreason }}</span>
                        <span v-show="i.manager">({{ i.manager }})</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr class="border-right">
              <td
                class="label-total text-right"
                :colspan="colSpan.total -1"
              >
                <strong>Totals:</strong>
              </td>
              <td class="text-center cell-running-total">{{ checkData.total_guests | number }}</td>
              <td class="text-right cell-running-total">
                <em>Sub:</em> {{ checkData.total | currency }}<br/>
                <em>Tax:</em> {{ checkData.total_tax | currency }}<br/>
                <span v-if="checkData.total_discounts > 0"><em>Disc:</em> {{ checkData.total_discounts | currency }}<br/></span>
                <span v-if="checkData.total_voids > 0"><em>Vds:</em> {{ checkData.total_voids | currency }}</span>
                </td>
              <td class="text-center cell-running-total">Tickets: {{ checkData.total_checks }}</td>
            </tr>
          </tfoot>
        </table>
      </div>
    </b-modal>
  </span>
</template>
<style scoped>
</style>
